import type * as BackendTypes from 'chaika-types';
import { LaboratoryServiceParams } from './laboratory';

export type FavoriteDataParams =
    | ReferralFavoriteDataParams
    | ReferralFavoriteDataParams[]
    | DrugFavoriteDataParams
    | DrugFavoriteDataParams[]
    | RecommendationFavoriteDataParams
    | RecommendationFavoriteDataParams[]
    | DiagnosisFavoriteDataParams
    | DiagnosisFavoriteDataParams[]
    | EntryTypeFavoriteDataParams
    | OfficeFavoriteDataParams;

export interface OfficeFavoriteDataParams {
    officeId: string;
}

export interface FavoriteData<D = FavoriteDataParams> extends Omit<BackendTypes.FavoriteViewModel, 'type' | 'data'> {
    type: FavoriteType;
    data: D;
}
export interface FavoriteCreateForm extends BackendTypes.FavoriteCreateForm {}
export interface FavoriteUpdateForm extends BackendTypes.FavoriteUpdateForm {}
export interface FavoriteOrderUpdateForm extends BackendTypes.FavoriteOrderUpdateForm {}
export interface FavoriteOrderUpdateParams extends BackendTypes.FavoriteOrderUpdateParams {}

export interface FavoriteListResponse {
    favorites: FavoriteData[];
}

export interface FavoriteResponse {
    favorite: FavoriteData;
}

export interface FavoriteListQuery {
    types: FavoriteType[];
}

export interface ReferralFavoriteCompositePart {
    id: string;
    laboratoryService?: LaboratoryServiceParams;
}

export interface ReferralFavoriteDataParams {
    name?: string;
    serviceId: string;
    duration?: number;
    authorId?: string;
    laboratoryServiceId?: string;
    laboratoryService?: LaboratoryServiceParams;
    compositeServices?: ReferralFavoriteCompositePart[];
    userId?: string;
    organizationId?: string;
    contractorId?: string;
}

export interface DrugFavoriteDataParams {
    id: string;
    activeSubstance: string;
    tradeNameIds?: string[];
    customTradeNames?: string[];
    tradeName?: string;
    frequencyIfReception: string;
    directions?: string;
    duration?: number;
}

export interface DrugFavoriteDataCreateParams extends DrugFavoriteDataParams {
    medicalCaseIds: string[];
    entryId: string;
}

export interface RecommendationFavoriteDataParams {
    comment: string;
    isImportant?: boolean;
    duration: string;
    durationCount: number;
}

export interface DiagnosisFavoriteDataParams {
    icdId: string;
    clinicalDiagnosis: string;
}

export interface EntryTypeFavoriteDataParams {
    entryTypeId: string;
}

export interface EntryTypeFavoriteDataParams {
    entryTypeId: string;
}

export enum FavoriteType {
    Referral = 'referral',
    Drug = 'drug',
    Recommendation = 'recommendation',
    Diagnosis = 'diagnosis',
    EntryType = 'entryType',
    Office = 'office',
}
